export default [
  {
    path: '/budget/staffList',
    meta: {
      title: '预算员管理',
    },
    component: () => import('@/views/budget/staff/list'),
  },
  {
    path: '/budget/libraryList',
    meta: {
      title: '预算库',
    },
    component: () => import('@/views/budget/library/list'),
  },
  {
    path: '/budget/libraryDetail',
    meta: {
      title: '预算库详情',
    },
    component: () => import('@/views/budget/library/detail'),
  },
  {
    path: '/budget/templateList',
    meta: {
      title: '预算模板',
    },
    component: () => import('@/views/budget/template/list'),
  },
  {
    path: '/budget/templateDetail',
    meta: {
      title: '预算模板详情',
    },
    component: () => import('@/views/budget/template/detail'),
  },
  {
    path: '/budget/reservationList',
    meta: {
      title: '预算单管理',
    },
    component: () => import('@/views/budget/reservation/list.vue'),
  },
  {
    path: '/budget/reservationDetail',
    meta: {
      title: '工单详情',
    },
    component: () => import('@/views/budget/reservation/detail.vue'),
  },
  {
    path: '/budget/visaList',
    meta: {
      title: '签证单',
    },
    component: () => import('@/views/budget/visa/list.vue'),
  },
  {
    path: '/budget/visaDetail',
    meta: {
      title: '签证单详情',
    },
    component: () => import('@/views/budget/visa/detail.vue'),
  },
  {
    path: '/budget/finalList',
    meta: {
      title: '决算单',
    },
    component: () => import('@/views/budget/final/list.vue'),
  },
  {
    path: '/budget/finalDetail',
    meta: {
      title: '决算单详情',
    },
    component: () => import('@/views/budget/final/detail.vue'),
  },
  //预算支付
  {
    path: '/budgetPay/detail/:payOrderCode',
    name: 'budgetPayDetail',
    meta: {
      layout: 'blank',
    },
    component: () => import('@/views/budget/pay/detail'),
  },
]